import styled from 'styled-components';

/* Contenedor común de las pantallas de venta (dueño y operador). */
export const SalesContainer = styled.div`
  background: var(--bg-section);
  min-height: calc(100vh - 68px);
  padding: 32px 20px 72px;

  > * {
    max-width: 880px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (max-width: 560px) {
    padding: 20px 16px 56px;
  }
`;

export const PageHead = styled.header`
  margin-bottom: 16px;

  h1 {
    font-size: var(--text-3xl);
    letter-spacing: -0.5px;
    margin-bottom: 4px;
  }

  p {
    color: var(--text-secondary);
  }

  @media (max-width: 560px) {
    h1 { font-size: var(--text-2xl); }
  }
`;

export const Panel = styled.section`
  background: var(--bg-card);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xs);
  padding: 22px;
  margin-bottom: 16px;
  min-width: 0;

  h2 {
    font-size: var(--text-lg);
    margin-bottom: 14px;
  }

  @media (max-width: 560px) {
    padding: 16px;
  }
`;

export const Notice = styled.div`
  background: ${props => (props.$error ? 'var(--danger-subtle)' : props.$warn ? 'var(--warning-subtle)' : 'var(--success-subtle)')};
  border: 1px solid ${props => (props.$error ? 'var(--danger-light)' : props.$warn ? 'var(--warning-border)' : 'var(--success-light)')};
  color: ${props => (props.$error ? 'var(--danger-dark)' : props.$warn ? 'var(--warning-dark)' : 'var(--success-dark)')};
  padding: 12px 16px;
  border-radius: var(--radius-md);
  font-size: var(--text-sm);
  line-height: 1.5;
  margin-bottom: 16px;
  overflow-wrap: anywhere;
`;

/* Pestañas Vender / Mis ventas (/ Escanear): visibles también en teléfono,
   donde el menú del encabezado está oculto. */
export const TabBar = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;

  a {
    flex: 1 1 auto;
    min-width: 0;
    text-align: center;
    padding: 10px 16px;
    border-radius: var(--radius-round);
    border: 1.5px solid var(--border-medium);
    background: var(--bg-card);
    color: var(--text-secondary);
    font-family: var(--font-brand);
    font-size: var(--text-sm);
    font-weight: 600;
    text-decoration: none;
    transition: all var(--transition-fast);
  }

  a:hover {
    border-color: var(--secondary);
    color: var(--secondary);
  }

  a[aria-current='page'] {
    background: var(--primary);
    border-color: var(--primary);
    color: var(--text-on-primary);
  }
`;

/* Fila etiqueta / valor (resumen, detalle, ticket). */
export const DetailList = styled.dl`
  display: grid;
  gap: 0;
  margin: 0;
  min-width: 0;

  .row {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding: 9px 0;
    border-bottom: 1px solid var(--border-light);
    font-size: var(--text-sm);
    min-width: 0;
  }

  .row:last-child { border-bottom: none; }

  dt {
    color: var(--text-secondary);
    flex-shrink: 0;
  }

  dd {
    margin: 0;
    text-align: right;
    font-weight: 600;
    min-width: 0;
    overflow-wrap: anywhere;
  }

  .strong dd {
    font-size: var(--text-lg);
    font-weight: 800;
  }

  @media (max-width: 400px) {
    .row { flex-direction: column; gap: 2px; }
    dd { text-align: left; }
  }
`;

export const MoneyTag = styled.span`
  color: var(--secondary);
  font-weight: 800;
`;

export const IvaTag = styled.span`
  color: var(--text-muted);
  font-size: var(--text-xs);
  font-weight: 600;
  white-space: nowrap;
`;
